/**
 * Utility functions for user-related operations
 */

/**
 * Generate user initials from display name
 * @param displayName - User's display name
 * @returns Initials (max 2 characters)
 */
export const getUserInitials = (displayName: string): string => {
  if (!displayName) return 'U';

  return displayName
    .split(' ')
    .map(name => name.charAt(0).toUpperCase())
    .join('')
    .slice(0, 2);
};

/**
 * Get avatar props for consistent user avatar display
 * @param user - User object with profile_picture and display_name
 * @param size - Avatar size (optional)
 * @returns Object with src and children props for Avatar component
 */
export const getAvatarProps = (
  user: { profile_picture?: string | null; display_name: string } | null,
  size?: number
) => {
  if (!user) {
    return {
      children: 'U',
      sx: size ? { width: size, height: size } : undefined
    };
  }

  const baseProps = {
    sx: size ? { width: size, height: size } : undefined
  };

  if (user.profile_picture) {
    return {
      ...baseProps,
      src: user.profile_picture,
      alt: `${user.display_name}'s profile picture`
    };
  }

  return {
    ...baseProps,
    children: getUserInitials(user.display_name)
  };
};

export const AVAILABLE_SPORTS = [
  { id: 'badminton', name: 'Badminton', icon: '🏸' },
  { id: 'basketball', name: 'Basketball', icon: '🏀' },
  { id: 'bouldering', name: 'Bouldering', icon: '🧗' },
  { id: 'tennis', name: 'Tennis', icon: '🎾' },
  { id: 'pickleball', name: 'Pickleball', icon: '🏓' },
  { id: 'hiking', name: 'Hiking', icon: '🥾' },
  { id: 'skiing', name: 'Ski/Snowboard', icon: '⛷️' },
  { id: 'golf', name: 'Golf', icon: '⛳' },
  { id: 'gym', name: 'Gym', icon: '💪' },
];
